import { render, staticRenderFns } from "./AfterLogin.vue?vue&type=template&id=fb4e5e8c&"
import script from "./AfterLogin.vue?vue&type=script&lang=js&"
export * from "./AfterLogin.vue?vue&type=script&lang=js&"
import style0 from "./AfterLogin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports